import { render, staticRenderFns } from "./ttshop_store.vue?vue&type=template&id=4d7c2f8c&scoped=true&"
import script from "./ttshop_store.vue?vue&type=script&lang=js&"
export * from "./ttshop_store.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_store.vue?vue&type=style&index=0&id=4d7c2f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c2f8c",
  null
  
)

export default component.exports